import { useAppSelector } from "../../../_app";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
} from "@mui/material";
import { CustomButton, CustomDateFieldSmall } from "../../../components";
import { useEffect, useState } from "react";
import { LeaveService } from "../../../_service";
import { Notify, Utils } from "../../../utils";
import { useNavigate } from "react-router-dom";

const LeaveTakeOns = () => {
  const user = useAppSelector((state) => state.user);

  const empId = useAppSelector((state) => state.employee.employee_info.id);
  const companyId = useAppSelector((state) => state.user.defaultCompnayId);
  const navigate = useNavigate();

  const tableHeaders = [
    "Type",
    "End of take-on period",
    "Cycle Start",
    "Cycle End",
    "Accrual",
    "Brought Forward (previous cycle)",
    "Taken plus adjustments",
    "Taken (Not on calendar)",
    "Closing balance calculated",
    "Closing balance override",
  ];

  const columnWidths = {
    "Type": "10%",
    "End of take-on period": "12%",
    "Cycle Start": "10%",
    "Cycle End": "10%",
    "Accrual": "8%",
    "Brought Forward (previous cycle)": "10%",
    "Taken plus adjustments": "10%",
    "Taken (Not on calendar)": "10%",
    "Closing balance calculated": "10%",
    "Closing balance override": "10%"
  };

  const testData = [
    {
      id: 22,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1030,
      created_by: null,
      updated_by: null,
      leave_type_name: "Annual Leave",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
    {
      id: 23,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1031,
      created_by: null,
      updated_by: null,
      leave_type_name: "Hospital",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
    {
      id: 24,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1032,
      created_by: null,
      updated_by: null,
      leave_type_name: "Sick",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
    {
      id: 25,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1033,
      created_by: null,
      updated_by: null,
      leave_type_name: "Maternity",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
    {
      id: 26,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1034,
      created_by: null,
      updated_by: null,
      leave_type_name: "Childcare",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
    {
      id: 27,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1035,
      created_by: null,
      updated_by: null,
      leave_type_name: "Paternity",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
    {
      id: 28,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1036,
      created_by: null,
      updated_by: null,
      leave_type_name: "Adoption",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
    {
      id: 29,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1037,
      created_by: null,
      updated_by: null,
      leave_type_name: "Infant care",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
    {
      id: 30,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1038,
      created_by: null,
      updated_by: null,
      leave_type_name: "Unpaid",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
    {
      id: 31,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1039,
      created_by: null,
      updated_by: null,
      leave_type_name: "happiness leave",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
    {
      id: 32,
      end_of_take_on_period: "2024-04-03",
      brought_forward: null,
      unrecorded_taken_leave: null,
      closing_balance_override: null,
      archived: false,
      employee: 337,
      leave_type: 1040,
      created_by: null,
      updated_by: null,
      leave_type_name: "mental health",
      cycle_start: "2024-09-06",
      cycle_end: "2025-09-06",
      accrual: "0.00",
      is_brought_forward: true,
      taken_plus_adjustment: "0.00",
      closing_balance: "0.00",
    },
  ];

  const [data, setData] = useState<any[]>([]);

  const handleBroughtForwardUpdate = (
    leave_type: number,
    newBroughtForward: number
  ) => {
    const updatedData = data.map((row) => {
      if (row.leave_type === leave_type) {
        const accrual = isNaN(parseFloat(row.accrual))
          ? 0
          : parseFloat(row.accrual) || 0;
        const unrecordedTakenLeave = isNaN(row.unrecorded_taken_leave)
          ? 0
          : row.unrecorded_taken_leave || 0;
        const validBroughtForward = isNaN(newBroughtForward)
          ? 0
          : newBroughtForward || 0;

          const validTakenPlusAdjustment = isNaN(row.taken_plus_adjustment)
          ? 0
          : row.taken_plus_adjustment || 0;

        const newClosingBalance = (
          (accrual + validTakenPlusAdjustment +
          validBroughtForward) -
          unrecordedTakenLeave
        ).toFixed(2);
        return {
          ...row,
          brought_forward: validBroughtForward,
          closing_balance: newClosingBalance,
        };
      }
      return row;
    });
    setData(updatedData);
  };

  const handleTakenNotOnCalendarUpdate = (
    leave_type: number,
    newUnrecordedTakenLeave: number
  ) => {
    const updatedData = data.map((row) => {
      if (row.leave_type === leave_type) {
        const accrual = isNaN(parseFloat(row.accrual))
          ? 0
          : parseFloat(row.accrual) || 0;
        const broughtForward = isNaN(row.brought_forward)
          ? 0
          : row.brought_forward || 0;
        const validUnrecordedTakenLeave = isNaN(newUnrecordedTakenLeave)
          ? 0
          : newUnrecordedTakenLeave || 0;

        const validTakenPlusAdjustment = isNaN(row.taken_plus_adjustment)
          ? 0
          : row.taken_plus_adjustment || 0;
        const newClosingBalance = (
          (accrual + validTakenPlusAdjustment +
          broughtForward) -
          validUnrecordedTakenLeave
        ).toFixed(2);
        return {
          ...row,
          unrecorded_taken_leave: validUnrecordedTakenLeave,
          closing_balance: newClosingBalance,
        };
      }
      return row;
    });
    setData(updatedData);
  };

  const handleClosingBalanceOverrideUpdate = (
    leave_type: number,
    value: number
  ) => {
    const updatedData = data.map((row) => {
      if (row.leave_type === leave_type) {
        const validValue = isNaN(value) ? 0 : value || 0;
        return { ...row, closing_balance_override: validValue };
      }
      return row;
    });
    setData(updatedData);
  };

  const getLeaveTakeOnsData = async () => {
    try {
      const res = await LeaveService._getLeaveTakeOns(empId, companyId);
      if (res.status >= 200 && res.status < 300) {
        setData(res?.data?.data || []);
      }
    } catch (error: any) {
      Utils.showErrorMessage(error);
    }
  };

  const handleSaveTakeOns = async () => {
    try {
      const res = await LeaveService._createUpdateTakeOns(data);
      if (res.status >= 200 && res.status < 300) {
        setData(res?.data?.data || []);
        Notify("Changes saved successfully", 1);
      }
    } catch (error: any) {
      Utils.showErrorMessage(error);
    }
  };

  const handleEndTakeOnPeriodUpdate = async (
    endDate: any,
    leaveType: string
  ) => {
    console.log("params date", endDate, leaveType);
    try {
      const res = await LeaveService._getLeaveTakeOnsOnDateChange(
        empId,
        leaveType,
        endDate
      );
      if (res.status >= 200 && res.status < 300) {
        console.log("dateChange res", endDate, res);
        const updatedData = data.map((row) => {
          if (row.leave_type === leaveType) {
            return {
              ...row,
              ...res?.data?.data,
              end_of_take_on_period: endDate,
              brought_forward: res?.data?.data?.is_brought_forward ? res?.data?.data.brought_forward : 0,
            };
          }
          return row;
        });
        setData(updatedData);
      }
    } catch (error: any) {
      Utils.showErrorMessage(error);
    }
  };

  useEffect(() => {
    getLeaveTakeOnsData();
  }, []);

  console.log("theData", data);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "0.5rem",
          marginLeft: "auto",
        }}
      >
        <CustomButton
          title="Save"
          onClick={() => handleSaveTakeOns()}
          styles={{
            marginRight: "1rem",
            whiteSpace: "nowrap",
          }}
          disable={data.length === 0}
        />
        <CustomButton
          type="secondary"
          title="Cancel"
          onClick={() => navigate("/dashboard/payroll/emp")}
          styles={{
            marginRight: "1rem",
            whiteSpace: "nowrap",
          }}
        />
      </div>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0 0.25rem 0.5rem rgba(0,0,0,0.1)",
          borderRadius: "0.5rem"
        }}
      >
        <Table stickyHeader sx={{ minWidth: 650, tableLayout: "fixed" }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              {tableHeaders.map((header, index) => (
                <TableCell
                  key={index}
                  sx={{
                    width: columnWidths[header],
                    fontWeight: "bold",
                    padding: "0.25rem",
                    whiteSpace: "normal",
                    backgroundColor: "#61677a",
                    textTransform: "capitalize",
                    fontSize: "0.875rem",
                    textAlign: "center",
                    color: "#fff",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

            <TableBody>
            {data?.length > 0
              ? data.map((row, index) => (
                <TableRow
                key={row?.leave_type || index}
                sx={{ "&:hover": { backgroundColor: "#f8f8f8" } }}
                >
                <TableCell sx={{ width: "10%", fontWeight: 500, padding: "4px 8px" }}>
                  {row?.leave_type_name}
                </TableCell>
                <TableCell sx={{ width: "12%", padding: "4px 8px" }}>
                  {/* <TextField
                type="date"
                defaultValue={row.end_of_take_on_period}
                size="small"
                fullWidth
                InputProps={{
                sx: {
                '&::-webkit-calendar-picker-indicator': {
                  display: 'none'
                },
                cursor: 'pointer'
                }
                }}
                /> */}
                  <CustomDateFieldSmall
                  date={row?.end_of_take_on_period}
                  setDate={(date: any) =>
                    handleEndTakeOnPeriodUpdate(date, row?.leave_type)
                  }
                  />
                </TableCell>
                <TableCell sx={{ width: "10%", textAlign: "center", padding: "4px 8px" }}>
                  {row?.cycle_start}
                </TableCell>
                <TableCell sx={{ width: "10%", textAlign: "center", padding: "4px 8px" }}>
                  {row?.cycle_end}
                </TableCell>
                <TableCell sx={{ width: "8%", textAlign: "center", padding: "4px 8px" }}>
                  {row?.accrual}
                </TableCell>
                <TableCell sx={{ width: "10%", padding: "4px 8px" }}>
                  <TextField
                  type="number"
                  placeholder="0"
                  defaultValue={row?.brought_forward}
                  disabled={!row?.is_brought_forward}
                  size="small"
                  fullWidth
                  onChange={(e) =>
                  handleBroughtForwardUpdate(
                  row?.leave_type,
                  parseFloat(e.target.value)
                  )
                  }
                  sx={{
                  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                  {
                  "-webkit-appearance": "none",
                  margin: 0,
                  },
                  "& input[type=number]": {
                  "-moz-appearance": "textfield",
                  },
                  "& .MuiOutlinedInput-root.Mui-disabled": {
                  backgroundColor: "#f4f4f4",
                  },
                  "& .MuiOutlinedInput-root.Mui-disabled:hover": {
                  backgroundColor: "#f4f4f4",
                  },
                  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ccc"
                  }
                  }}
                  />
                </TableCell>
                <TableCell sx={{ width: "10%", textAlign: "center", padding: "4px 8px" }}>
                  {row?.taken_plus_adjustment}
                </TableCell>
                <TableCell sx={{ width: "10%", textAlign: "center", padding: "4px 8px" }}>
                  <TextField
                  type="number"
                  defaultValue={row?.unrecorded_taken_leave}
                  size="small"
                  fullWidth
                  onChange={(e) =>
                    handleTakenNotOnCalendarUpdate(
                    row?.leave_type,
                    parseFloat(e.target.value)
                    )
                  }
                  sx={{
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                    {
                      "-webkit-appearance": "none",
                      margin: 0,
                    },
                    "& input[type=number]": {
                    "-moz-appearance": "textfield",
                    },
                  }}
                  />
                </TableCell>
                <TableCell sx={{ width: "10%", textAlign: "center", padding: "4px 8px" }}>
                  {row?.closing_balance}
                </TableCell>
                <TableCell sx={{ width: "10%", textAlign: "center", padding: "4px 8px" }}>
                  <TextField
                  type="number"
                  defaultValue={row?.closing_balance_override}
                  size="small"
                  fullWidth
                  onChange={(e) =>
                    handleClosingBalanceOverrideUpdate(
                    row?.leave_type,
                    parseFloat(e.target.value)
                    )
                  }
                  sx={{
                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                    {
                      "-webkit-appearance": "none",
                      margin: 0,
                    },
                    "& input[type=number]": {
                    "-moz-appearance": "textfield",
                    },
                  }}
                  />
                </TableCell>
                </TableRow>
              ))
              : null}
            </TableBody>
        </Table>
      </TableContainer>

      {/* IF No Data */}
      {data?.length === 0 && (
        <div
          style={{
            width: "90%",
            padding: "2rem",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            style={{
              color: "#666",
              fontSize: "1rem",
              fontWeight: 500,
              margin: 0,
            }}
          >
            No data available
          </p>
        </div>
      )}
    </div>
  );
};

export default LeaveTakeOns;
